export const StaticMenuItems = [];
